// extracted by mini-css-extract-plugin
export default {"button":"MwkjQLryKS0sJ7nKGuPo","placeHolderShimmer":"WCVbjbX54DHwX85u0EkA"};